<template>
  <div>
    <v-app id="inspire" v-if="isAuthorizedUser">
      <div style="width: 100%" else>
        <v-navigation-drawer color="dark" v-model="drawer" dark app>
          <v-list dense>
            <v-list-item
              v-for="(menu, i) in $routes"
              :key="`${i}+${menu.path}`"
              :to="menu.path"
            >
              <v-list-item-action class="mr-5">
                <v-icon>{{ menu.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ menu.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item>
              <v-list-item-action>
                <v-icon>{{ menu.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Home</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
          </v-list>
        </v-navigation-drawer>

        <v-app-bar app color="dark" dark>
          <v-row class="justify-space-between">
            <v-col cols="12" md="12" lg="9" dense>
              <v-app-bar-nav-icon
                @click.stop="drawer = !drawer"
              ></v-app-bar-nav-icon>
              <!-- <span class="title" v-if="allFlags.SOG2248"
                >**WG Plan Mapping</span
              > -->
              <span class="title">WG Plan Mapping</span>
            </v-col>
          </v-row>
        </v-app-bar>

        <v-main color="primary">
          <router-view></router-view>
        </v-main>
      </div>
      <http-response
        :text="httpText"
        :color="httpColor"
        :isActive="httpIsActive"
      ></http-response>
      <process-loader :isActive="isProcessingActive"></process-loader>
    </v-app>
    <pre-loader v-else></pre-loader>
  </div>
</template>

<script>
import Mgr from "@/services/SecurityService";
import preLoader from "./components/common/pre-loader.vue";

export default {
  components: { preLoader },
  name: "App",
  data: () => ({
    drawer: null,
    mgr: new Mgr(),
  }),
  mounted() {
    const vm = this;

    vm.mgr.getSignedIn().then(
      (signIn) => {
        vm.signedIn = signIn;
        vm.setRoles();
      },
      (err) => {
        console.log(err);
      }
    );
  },
};
</script>
